import { render, staticRenderFns } from "./ghost.vue?vue&type=template&id=34f8750e"
import script from "./ghost.vue?vue&type=script&lang=js"
export * from "./ghost.vue?vue&type=script&lang=js"
import style0 from "./ghost.vue?vue&type=style&index=0&id=34f8750e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports